
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Text356763765",
      {"classes":{"root":"Text356763765__root","srOnly":"a11y2708470387__srOnly","sr-only":"Text356763765__sr-only"},"vars":{"wix-color-5":"--wix-color-5","wix-color-4":"--wix-color-4","wut-text-color":"--wut-text-color","wut-placeholder-color":"--wut-placeholder-color","wix-ui-tpa-text-main-text-color":"--wix-ui-tpa-text-main-text-color","wix-ui-tpa-text-main-text-font":"--wix-ui-tpa-text-main-text-font","primary-color":"--Text356763765-primary-color","secondary-color":"--Text356763765-secondary-color"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  